export default function ErrorMessage({ children }: { children: React.ReactNode }) {
  return (
    <div className='bg-red-500 text-white p-4 text-center'>
      <p>{children}</p>
    </div>
  );
}
